(function () {
    'use strict';

    angular
        .module('salesflare')
        .service('companies', companiesService);

    function companiesService($q, sfHttp, $exceptionHandler, utils, config, company, flagsService) {

        this.get = function (search) {

            if (!search) {
                return $q.resolve([]);
            }

            if (flagsService.get('useInternalCompanyAutocomplete') === true) {
                const request = {
                    ignoreLoadingBar: true,
                    params: {
                        name: search
                    }
                };

                return sfHttp.get(`${config.apiUrl}companies/autocomplete`, request);
            }

            search = search.slice(0, 29);

            const url = 'https://autocomplete.clearbit.com/v1/companies/suggest';
            const request = {
                cache: false,
                ignoreLoadingBar: true,
                params: {
                    query: search === '' ? undefined : search
                },
                withCredentials: false,
                noToast: true // We don't want to show clearbit errors to the user
            };

            return sfHttp.get(url, request)
                .then((response) => {

                    // For some reason the api started to return dupes so we unique the list based on domain here.
                    // See https://github.com/Salesflare/Server/issues/8015.
                    response.data = utils.unique(response.data, 'domain');

                    return company.getWindowedLogoSecret()
                        .then((secretResponse) => {

                            const secretData = secretResponse.data;

                            const secret = secretData.secret;
                            const window = secretData.timeWindow;

                            // API started to return empty company logo's, fix uses clearbit logo API to fix it.
                            response.data.forEach(function (companyData) {
                                companyData.logo = companyData.logo ?? config.logoApi + companyData.domain + `?sig=${secret}&tw=${window}`;
                            });

                            return response;
                        });

                })
                .catch(function (err) {

                    // We do want to log these errors as we do not log them server side (since not our server) like on our api
                    const error = new Error('Clearbit /companies called failed');
                    error.original = err;
                    $exceptionHandler(error);
                });
        };
    }
})();
